// @flow
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import ScrollUpButton from 'react-scroll-up-button';
import styles from './BackToTop.module.scss';

type Props = {||};

const BackToTop = () => {
    return (
        <ScrollUpButton
            ContainerClassName={styles['ScrollUpButton__Container']}
            ShowAtPostion={1250}
            TransitionClassName={styles['ScrollUpButton__Toggled']}
        >
            <Fragment>
                <div className={styles.arrowWrapper}>
                    <div className={styles.arrowUp} />
                </div>
                <div className={styles.backToTopText}>
                    <FormattedMessage id="back_to_top_button" />
                </div>
            </Fragment>
        </ScrollUpButton>
    );
};

export default React.memo<Props>(BackToTop);
